import mixpanel from 'mixpanel-browser';
import { ITrackingProvider } from "./tracking.interface";

export class MixpanelTrackingProvider implements ITrackingProvider {
  track(title: string, properties?: any): void {
    mixpanel.track(title, properties);
  }

  trackPageView(title: string, properties?: any): void {
    mixpanel.track_pageview(properties, { event_name: title });
  }

  identifyUser(user: string, properties?: any): void {
    mixpanel.identify(user);
    mixpanel.people.set(properties);
  }

  aliasUser(user: string, properties?: any): void {
    mixpanel.alias(user);
    mixpanel.people.set(properties);
  }
}
